import { useState } from 'react';
import { Button, Group, Paper, Stack, Text } from '@mantine/core';
import { useMutation } from 'urql';
import { ErrorAlert } from '@/components/error-alert';
import { getErrorMessage } from '@/lib/error-message';
import { UpdatePersonaMutation } from './graphql';
import type { PersonaDetail } from './graphql';
import { OutputHandleEditor, readOutputHandles } from '@/components/output-handles';

export function PersonaOutputsPanel({ persona }: { persona: PersonaDetail }) {
  const [, runUpdatePersona] = useMutation(UpdatePersonaMutation);

  const [outputHandles, setOutputHandles] = useState(readOutputHandles(persona.outputHandles));
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSave = async () => {
    setIsSaving(true);
    setError(null);

    const result = await runUpdatePersona({ personaId: persona.id, set: { outputHandles } });

    setIsSaving(false);
    setError(result.error ? getErrorMessage(result.error, 'Failed to save outputs') : null);
  };

  return (
    <Paper p="lg" withBorder radius="lg">
      <Stack gap="md">
        <ErrorAlert message={error} />
        <div>
          <Text fw={500}>Output Handles</Text>
          <Text size="sm" c="dimmed">
            Define exit conditions for the AI conversation. The AI will route to these outputs based on the criteria.
          </Text>
        </div>

        <OutputHandleEditor handles={outputHandles} onChange={setOutputHandles} />

        <Group justify="flex-end">
          <Button onClick={handleSave} loading={isSaving}>
            Save Outputs
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
}
